var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77101 7.16245C2.72099 7.23007 2.68769 7.30856 2.67382 7.39152C2.65893 7.47719 2.66523 7.5652 2.69217 7.64788C2.71911 7.73055 2.76587 7.80538 2.82837 7.86584L4.98008 10.0132L2.60639 12.3869C2.3135 12.6798 2.3135 13.1546 2.60639 13.4475C2.89928 13.7404 3.37416 13.7404 3.66705 13.4475L6.04182 11.0727L8.0725 13.0993C8.1223 13.1487 8.18135 13.1878 8.24629 13.2143C8.31122 13.2408 8.38075 13.2543 8.45088 13.2539H8.53615C8.61771 13.2379 8.6944 13.2031 8.7601 13.1522C8.82581 13.1013 8.87869 13.0357 8.91454 12.9607L10.6199 9.54992L13.1781 6.99182C13.2765 6.89255 13.332 6.75857 13.3326 6.61876C13.333 6.54862 13.3196 6.47909 13.293 6.41416C13.2665 6.34923 13.2275 6.29017 13.1781 6.24037L9.68197 2.73896C9.58212 2.6397 9.44705 2.58398 9.30625 2.58398C9.16546 2.58398 9.03038 2.6397 8.93053 2.73896L6.37242 5.29707L2.96161 7.00247C2.88634 7.04001 2.82103 7.09483 2.77101 7.16245Z",
    fill: "#677B99"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/icon-pin.50e31220d690208097eb50c380f5acd2.svg";
export { ForwardRef as ReactComponent };